<template>
  <div class="reset-password-page">
    <div class="container reset-password-page__container">
      <h1 class="reset-password-page__heading">Reset Password</h1>

      <FormulateForm
        @submit="submitPasswordReset"
        class="formulate-form reset-password-page__formulate-form"
      >
        <div v-if="resetPasswordSuccessMsg" class="resetPasswordSuccessMsgBox">
          <p class="body-copy body-copy--align-center">
            Your Password has been reset Successfully
          </p>
        </div>

        <div v-if="resetPasswordErrorMsg" class="resetPasswordErrorMsgBox">
          <p class="body-copy body-copy--align-center body-copy--color-error">
            {{ resetPasswordErrorMessage }}
          </p>
        </div>

        <FormulateInput
          type="password"
          name="password"
          v-model="newpassword"
          label="New Password"
          :disabled="resetPasswordSuccessMsg || resetPasswordErrorMsg"
          :wrapper-class="['formulate-input-wrapper--container']"
          :label-class="['formulate-input-label--contained']"
          :element-class="['formulate-input-element--contained']"
        />

        <div v-if="passwordError" class="error-message">
          {{ passwordError }}
        </div>

        <FormulateInput
          type="password"
          name="password_confirm"
          v-model="confirmpassword"
          label="Confirm New Password"
          :disabled="resetPasswordSuccessMsg || resetPasswordErrorMsg"
          :wrapper-class="['formulate-input-wrapper--container']"
          :label-class="['formulate-input-label--contained']"
          :element-class="['formulate-input-element--contained']"
        />
        <div v-if="passwordConfirmationError" class="error-message">
          {{ passwordConfirmationError }}
        </div>

        <div class="formulate-form__form-footer">
          <FormulateInput type="submit" name="Reset" :input-class="'btn'" />
        </div>
      </FormulateForm>
    </div>
  </div>
</template>

<script>
import userMixin from "../mixins/userMixin";

export default {
  name: "ResetPasswordPage",
  metaInfo: {
    title: "Khonsu - ResetPasswordPage",
  },
  components: {},
  data: function () {
    return {
      oldpassword: "",
      newpassword: "",
      confirmpassword: "",
      resetPasswordSuccessMsg: false,
      resetPasswordErrorMsg: false,
      resetPasswordErrorMessage: "",
      passwordError: "",
      passwordConfirmationError: "",
    };
  },
  methods: {
    async submitPasswordReset() {
      this.passwordError = ""; // Clear any previous errors
      this.passwordConfirmationError = "";

      if (
        !/\d/.test(this.newpassword) ||
        !/[!@#$%^&*]/.test(this.newpassword)
      ) {
        this.passwordError =
          "Password must include at least one number and one special character.";
      }

      if (this.newpassword.length < 8) {
        this.passwordError = "Password must be at least 8 characters long.";
      }

      if (this.newpassword !== this.confirmpassword) {
        this.passwordConfirmationError =
          "Password confirmation does not match.";
      }

      if (!this.passwordError && !this.passwordConfirmationError) {
        // Only attempt the reset if there are no validation errors
        let resetCode = localStorage.getItem("_khonsu_app_resetCode");
        let resetEmail = localStorage.getItem("_khonsu_app_resetEmail");
        if (resetCode === this.$route.params.resetCode) {
          let resetPassword = await this.$store.dispatch(
            "UserManagement/resetPassword",
            {
              email: resetEmail,
              password_old: this.oldpassword,
              password: this.newpassword,
              password_confirmation: this.confirmpassword,
              resetCode: this.$route.params.resetCode,
            }
          );
          if (resetPassword) {
            this.resetPasswordSuccessMsg = true;
            this.resetPasswordErrorMsg = false;
          } else {
            this.resetPasswordSuccessMsg = false;
            this.resetPasswordErrorMsg = true;
            let errorCode = userMixin.methods.getUserResetErrorStatus();
            switch (errorCode) {
              case "422":
                this.resetPasswordErrorMessage = JSON.parse(
                  sessionStorage.getItem("_khonsu_user_reset_failed_msg")
                ).message;
                break;
              case "404":
                this.resetPasswordErrorMessage = JSON.parse(
                  sessionStorage.getItem("_khonsu_user_reset_failed_msg")
                ).message;
                break;
              case "410":
                this.resetPasswordErrorMessage = JSON.parse(
                  sessionStorage.getItem("_khonsu_user_reset_failed_msg")
                ).message;
                break;
              case "412":
                this.resetPasswordErrorMessage = JSON.parse(
                  sessionStorage.getItem("_khonsu_user_reset_failed_msg")
                ).message;
                break;
              default:
                break;
            }
          }
        }
      }
    },
  },
};
</script>
